import { plainToClass } from "class-transformer";
import { ActionItemListingDto, ActionItemDropdown, SiteLevelSummaryDto } from "../action-items.objects";
import { Unique } from "../../../../shared/scripts/array-functions";
import { IFilter } from "../../../../shared/scripts/filtering/filtering.entities";
import { InitializeFilterDropdown } from "../../../../shared/scripts/filtering/filtering.utilities";

class ActionItemDialogViewModel {
    Id: number = 0;
    TypeId: any = null;
    Source: string = "";
    StatusId: any = null;
    DateIdentified: string = "";
    DateDue: string = "";
    IsUrgent: boolean = false;
    IsCritical: boolean = false;
    CriticalTypeId: number | null = null;
    Notes: string = "";
    AssignedSiteStudies: any[] = [];
}

export class ActionItemDialog implements IFilter {
    actionItems: ActionItemListingDto[];
    actionItemTypes: ActionItemDropdown[];
    actionItemStatuses: ActionItemDropdown[];
    actionItemCriticalTypes: ActionItemDropdown[];
    allSites: SiteLevelSummaryDto[];
    assignTable: any;
    filterDropdownIds: string[];
    checkedSiteStudyIds: Set<number> = new Set();
    //viewModel: any;
    //viewModel: ActionItemDialogViewModel = new ActionItemDialogViewModel();
    successCallback: (response: any) => void;

    constructor(allActionItemsJson: any, allActionItemTypesJson: any, allActionItemStatusesJson: any, allActionItemCriticalTypesJson: any, allSitesJson: any) {
        $(() => {
            this.actionItems = plainToClass(ActionItemListingDto, <ActionItemListingDto[]>allActionItemsJson);
            this.actionItemTypes = plainToClass(ActionItemDropdown, <ActionItemDropdown[]>allActionItemTypesJson);
            this.actionItemStatuses = plainToClass(ActionItemDropdown, <ActionItemDropdown[]>allActionItemStatusesJson);
            this.actionItemCriticalTypes = plainToClass(ActionItemDropdown, <ActionItemDropdown[]>allActionItemCriticalTypesJson);
            this.allSites = plainToClass(SiteLevelSummaryDto, <SiteLevelSummaryDto[]>allSitesJson);
            this.allSites = this.allSites.map((site: SiteLevelSummaryDto) => {
                site.initialize();
                return site;
            });
            this.filterDropdownIds = [
                '#assign-study-dropdown', '#assign-site-manager-dropdown'
            ];
            this.populateDialogDropdowns();
            this.initializeAssignFilters();
            this.initializeAssignTable();
            this.initializeCriticalTypeToggle();
            const fieldMap: { [key: string]: string } = {
                TypeId: '#actionItemType',
                Source: '#actionItemSource',
                StatusId: '#actionItemStatus',
                DateIdentified: '#actionItemDate',
                DateDue: '#actionItemDueDate',
                IsUrgent: '#actionItemUrgent',
                IsCritical: '#actionItemCritical',
                CriticalTypeId: '#actionItemCriticalType',
                Notes: '#actionItemNotes'
            };
            this.initializeSaveButton();
            $('#newActionItemDialog').on('hidden.bs.modal', () => {
                this.checkedSiteStudyIds.clear();
                this.clearDialogFields();
                this.resetFilters();
            });
        });
    }

    populateDialogDropdowns(): void {
        const $typeDropdown = $('#actionItemType');
        $typeDropdown.empty();
        this.actionItemTypes.forEach(type => {
            $typeDropdown.append(`<option value="${type.Id}">${type.Name}</option>`);
        });
        const $statusDropdown = $('#actionItemStatus');
        $statusDropdown.empty();
        this.actionItemStatuses.forEach(status => {
            $statusDropdown.append(`<option value="${status.Id}">${status.Name}</option>`);
        });
        const $criticalTypeDropdown = $('#actionItemCriticalType');
        $criticalTypeDropdown.empty();
        //$criticalTypeDropdown.append('<option value="">None Selected</option>');
        this.actionItemCriticalTypes.forEach(ct => {
            $criticalTypeDropdown.append(`<option value="${ct.Id}">${ct.Name}</option>`);
        });
    }

    initializeAssignFilters(): void {
        let studyValues: string[] = Unique(this.allSites.map(site => site.StudyName), true, ["None Selected"]);
        InitializeFilterDropdown('#assign-study-dropdown', studyValues, this);
        let siteManagerValues: string[] = [];
        this.allSites.forEach(site => { siteManagerValues.push(...site.UserNames); });
        siteManagerValues.push("Unassigned");
        siteManagerValues = Unique(siteManagerValues, true, ["None Selected"]);
        InitializeFilterDropdown('#assign-site-manager-dropdown', siteManagerValues, this);
        $('#assign-study-dropdown').on('change', () => this.triggerAssignTableFilter());
        $('#assign-site-manager-dropdown').on('change', () => this.triggerAssignTableFilter());
    }

    initializeAssignTable(): void {
        const self = this;
        this.assignTable = $('#action-item-assign-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '40vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[2, 'asc']],
            columns: [
                {
                    data: null,
                    title: '<input type="checkbox" />',
                    className: "ctms-table-col-check",
                    orderable: false,
                    render: function (data, type, row) {
                        return `<input type="checkbox" class="assign-checkbox" data-id="${row.Id}" />`;
                    }
                },
                { data: "SiteName", title: "Site Name" },
                { data: "SiteNumber", title: "Site Number" },
                { data: "StudyName", title: "Study Name" },
                {
                    data: "UserNames",
                    title: "Site Manager",
                    render: function (data) {
                        return Array.isArray(data) ? data.join(", ") : "";
                    }
                }
            ],
            data: this.allSites
        });

        // Listen for checkbox changes
        $('#action-item-assign-table tbody').on('change', '.assign-checkbox', function () {
            const id = Number($(this).attr('data-id'));
            if ($(this).prop('checked')) {
                self.checkedSiteStudyIds.add(id);
            } else {
                self.checkedSiteStudyIds.delete(id);
            }
        });

        // On table draw, restore checked state
        this.assignTable.on('draw', function () {
            self.assignTable.rows().every(function () {
                const $row = $(this.node());
                const rowData = this.data();
                const $checkbox = $row.find('.assign-checkbox');
                if ($checkbox.length && self.checkedSiteStudyIds.has(rowData.Id)) {
                    $checkbox.prop('checked', true);
                } else {
                    $checkbox.prop('checked', false);
                }
            });
        });

        this.assignTable.draw();

        // Search filter logic
        $('#assign-search-input').on('input', function () {
            $('#action-item-assign-table').DataTable().search(String($(this).val() ?? '')).draw();
        });
        $('#assign-search-clear').on('click', function () {
            $('#assign-search-input').val('');
            $('#action-item-assign-table').DataTable().search('').draw();
        });

        $('#newActionItemDialog').on('shown.bs.modal', () => {
            if (this.assignTable) {
                this.assignTable.columns.adjust();
            }
        });
    }

    initializeCriticalTypeToggle(): void {
        const $criticalCheckbox = $('#actionItemCritical');
        const $criticalTypeWrapper = $('#actionItemCriticalTypeWrapper');
        $criticalCheckbox.on('change', function () {
            if ($(this).prop('checked')) {
                $criticalTypeWrapper.show();
            } else {
                $criticalTypeWrapper.hide();
                $('#actionItemCriticalType').val('');
            }
        });
        // On page load, ensure correct visibility
        if (!$criticalCheckbox.is(':checked')) {
            $criticalTypeWrapper.hide();
            $('#actionItemCriticalType').val('');
        }
    }

    initializeSaveButton(): void {
        $('#newActionItemDialog .ctms-button-save').on('click', () => {
            const payload: any = {
                Id: $('#actionItemId').val(),
                TypeId: $('#actionItemType').val(),
                Source: $('#actionItemSource').val(),
                StatusId: $('#actionItemStatus').val(),
                DateIdentified: $('#actionItemDate').val(),
                DateDue: $('#actionItemDueDate').val(),
                IsUrgent: $('#actionItemUrgent').prop('checked'),
                IsCritical: $('#actionItemCritical').prop('checked'),
                CriticalTypeId: $('#actionItemCriticalType').val() ? Number($('#actionItemCriticalType').val()) : null,
                Notes: $('#actionItemNotes').val(),
                AssignedSiteStudies: this.getSelectedAssignedSiteStudies()
            };
            $.ajax({
                url: '/secure/ctms/action-items/action-items?handler=SaveActionItem',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    ...payload
                }),
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() as string
                },
                success: (response) => {
                    $('#newActionItemDialog').modal('hide');
                    this.successCallback(response);
                },
                error: (xhr) => {
                    alert('Error saving action item.');
                }
            });
        });
    }

    getSelectedAssignedSiteStudies(): any[] {
        const checkedRows: any[] = [];
        this.allSites.forEach(site => {
            if (this.checkedSiteStudyIds.has(site.Id)) {
                checkedRows.push(site);
            }
        });
        return checkedRows.map(row => ({
            SiteStudyId: row.Id,
            SiteId: row.SiteId,
            SiteName: row.SiteName,
            StudyId: row.StudyId,
            StudyName: row.StudyName
        }));
    }

    refresh(): void {
        this.assignTable.columns.adjust();
    }

    normalizeToStringArray(val: any): string[] {
        if (Array.isArray(val)) return val.map(String);
        if (val === undefined || val === null) return [];
        return [String(val)];
    }

    updateTable(matchingSites: SiteLevelSummaryDto[]): void {
        this.assignTable.clear();
        this.assignTable.rows.add(matchingSites).draw();
    }

    triggerAssignTableFilter(): void {
        let matchingSites: SiteLevelSummaryDto[] = [];
        let siteMatches: boolean;
        this.allSites.forEach((site: SiteLevelSummaryDto) => {
            siteMatches = true;
            if (!site.matchesFilter(this.getSelectedDropdownValues('#assign-study-dropdown'), this.getSelectedDropdownValues('#assign-site-manager-dropdown'))) {
                siteMatches = false;
            }
            if (siteMatches) { matchingSites.push(site); }
        });
        this.updateTable(matchingSites);
    }

    getSelectedDropdownValues(selectId: string): any {
        return $(selectId).val();
    }

    triggerFilter(): void {
    }

    resetFilters(): void {
        this.filterDropdownIds.forEach((dropdownId: string) => {
            $(dropdownId).selectpicker('selectAll');
            $(dropdownId).selectpicker('refresh');
        });
        $('#assign-search-input').val('');
        this.assignTable.search('').draw();
        this.updateTable(this.allSites);
    }

    clearDialogFields(): void {
        $('#actionItemType').val($('#actionItemType option:first').val()).trigger('change');
        $('#actionItemSource').val('');
        $('#actionItemStatus').val($('#actionItemStatus option:first').val()).trigger('change');
        $('#actionItemDate').val('');
        $('#actionItemDueDate').val('');
        $('#actionItemUrgent').prop('checked', false);
        $('#actionItemCritical').prop('checked', false);
        $('#actionItemCriticalType').val('');
        $('#actionItemNotes').val('');
        $('#actionItemCriticalTypeWrapper').hide();
        $('#actionItemId').val(0);
        this.checkedSiteStudyIds.clear();
    }

    populateDialogFieldsFromDto(dto: any): void {
        $('#actionItemId').val(dto.id);
        $('#actionItemType').val(dto.typeId).trigger('change');
        $('#actionItemSource').val(dto.source).trigger('change');
        $('#actionItemStatus').val(dto.statusId).trigger('change');
        $('#actionItemDate').val(dto.dateIdentified).trigger('change');
        $('#actionItemDueDate').val(dto.dateDue).trigger('change');
        $('#actionItemUrgent').prop('checked', !!dto.isUrgent).trigger('change');
        $('#actionItemCritical').prop('checked', !!dto.isCritical).trigger('change');
        $('#actionItemCriticalType').val(dto.criticalTypeId || '').trigger('change');
        $('#actionItemNotes').val(dto.notes).trigger('change');

        if (this.assignTable && Array.isArray(dto.assignedSiteStudies)) {
            this.checkedSiteStudyIds.clear();
            dto.assignedSiteStudies.forEach((s: any) => {
                if (s.siteStudyId !== undefined && s.siteStudyId !== null) {
                    this.checkedSiteStudyIds.add(s.siteStudyId);
                }
            });
            this.assignTable.draw();
        }
    }
}

// Readonly dialog logic
export class ActionItemDialogReadonly implements IFilter {
    actionItems: ActionItemListingDto[];
    actionItemTypes: ActionItemDropdown[];
    actionItemStatuses: ActionItemDropdown[];
    actionItemCriticalTypes: ActionItemDropdown[];
    allSites: SiteLevelSummaryDto[];
    assignedSites: SiteLevelSummaryDto[];
    assignTable: any;
    filterDropdownIds: string[];
    successCallback: (response: any) => void;

    constructor(allActionItemsJson: any, allActionItemTypesJson: any, allActionItemStatusesJson: any, allActionItemCriticalTypesJson: any, allSitesJson: any) {
        $(() => {
            this.actionItems = plainToClass(ActionItemListingDto, <ActionItemListingDto[]>allActionItemsJson);
            this.actionItemTypes = plainToClass(ActionItemDropdown, <ActionItemDropdown[]>allActionItemTypesJson);
            this.actionItemStatuses = plainToClass(ActionItemDropdown, <ActionItemDropdown[]>allActionItemStatusesJson);
            this.actionItemCriticalTypes = plainToClass(ActionItemDropdown, <ActionItemDropdown[]>allActionItemCriticalTypesJson);
            this.allSites = plainToClass(SiteLevelSummaryDto, <SiteLevelSummaryDto[]>allSitesJson);
            this.allSites = this.allSites.map((site: SiteLevelSummaryDto) => {
                site.initialize();
                return site;
            });
            this.assignedSites = this.allSites;
            this.filterDropdownIds = [
                '#assign-study-dropdown', '#assign-site-manager-dropdown'
            ];
            this.populateDialogDropdowns();
            this.initializeAssignTable();
        });
    }

    populateDialogDropdowns(): void {
        $('#assign-study-dropdown').empty();
        $('#assign-site-manager-dropdown').empty();

        let studyValues: string[] = Unique(this.assignedSites.map(site => site.StudyName), true, ["None Selected"]);
        InitializeFilterDropdown('#assign-study-dropdown', studyValues, this);
        let siteManagerValues: string[] = [];
        this.assignedSites.forEach(site => { siteManagerValues.push(...site.UserNames); });
        siteManagerValues.push("Unassigned");
        siteManagerValues = Unique(siteManagerValues, true, ["None Selected"]);
        InitializeFilterDropdown('#assign-site-manager-dropdown', siteManagerValues, this);
        $('#assign-study-dropdown').on('change', () => this.triggerAssignTableFilter());
        $('#assign-site-manager-dropdown').on('change', () => this.triggerAssignTableFilter());
    }

    initializeAssignTable(): void {
        this.assignTable = $('#action-item-assign-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '40vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[1, 'asc']],
            columns: [
                { data: "SiteName", title: "Site Name" },
                { data: "SiteNumber", title: "Site Number" },
                { data: "StudyName", title: "Study Name" },
                {
                    data: "UserNames",
                    title: "Site Manager",
                    render: function (data) {
                        return Array.isArray(data) ? data.join(", ") : "";
                    }
                }
            ],
            data: this.allSites
        });

        // Search filter logic
        $('#assign-search-input').on('input', function () {
            $('#action-item-assign-table').DataTable().search(String($(this).val() ?? '')).draw();
        });
        $('#assign-search-clear').on('click', function () {
            $('#assign-search-input').val('');
            $('#action-item-assign-table').DataTable().search('').draw();
        });

        $('#newActionItemDialog').on('shown.bs.modal', () => {
            if (this.assignTable) {
                this.assignTable.columns.adjust();
            }
        });
    }

    updateTable(matchingSites: SiteLevelSummaryDto[]): void {
        this.assignTable.clear();
        this.assignTable.rows.add(matchingSites).draw();
    }

    triggerAssignTableFilter(): void {
        let matchingSites: SiteLevelSummaryDto[] = [];
        let siteMatches: boolean;
        this.assignedSites.forEach((site: SiteLevelSummaryDto) => {
            siteMatches = true;
            if (!site.matchesFilter(this.getSelectedDropdownValues('#assign-study-dropdown'), this.getSelectedDropdownValues('#assign-site-manager-dropdown'))) {
                siteMatches = false;
            }
            if (siteMatches) { matchingSites.push(site); }
        });
        this.updateTable(matchingSites);
    }

    getSelectedDropdownValues(selectId: string): any {
        return $(selectId).val();
    }

    populateDialogFieldsFromDto(dto: any): void {
        const typeObj = this.actionItemTypes.find(t => t.Id === dto.typeId);
        const statusObj = this.actionItemStatuses.find(t => t.Id === dto.statusId);
        const criticalObj = this.actionItemCriticalTypes.find(t => t.Id === dto.criticalTypeId);
        $('#actionItemId').val(dto.id);
        $('#actionItemTypeReadonly').text(typeObj ? typeObj.Name : '');
        $('#actionItemSourceReadonly').text(dto.source || '');
        $('#actionItemStatusReadonly').text(statusObj ? statusObj.Name : '');
        $('#actionItemDateReadonly').text(dto.dateIdentified || '');
        $('#actionItemDueDateReadonly').text(dto.dateDue || '');
        $('#actionItemUrgentReadonly').text(dto.isUrgent ? 'Yes' : 'No');
        $('#actionItemCriticalReadonly').text(dto.isCritical ? 'Yes' : 'No');
        $('#actionItemCriticalTypeReadonly').text(criticalObj ? criticalObj.Name : '');
        $('#actionItemNotesReadonly').text(dto.notes || '');

        if (this.assignTable && Array.isArray(dto.assignedSiteStudies)) {
            const assignedIds = new Set(dto.assignedSiteStudies.map((s: any) => s.siteStudyId));
            this.assignedSites = this.allSites.filter(site => assignedIds.has(site.Id));
            this.updateTable(this.assignedSites);
            this.populateDialogDropdowns();
        }
    }

    triggerFilter(): void { }
    resetFilters(): void { }
}

